import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sidebar: {
		id: 'business-app-wrapper.ui.app-wrapper.sidebar',
		defaultMessage: 'Sidebar',
		description:
			'Accessible label for the sidebar section, providing additional information such as view settings or work item details.',
	},
});
